/**
 * VolHistHisto — Vol. Histórica (Histograma).
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLVolatilidade.cs, classe
 * FML.VolHistHisto). Painel próprio, 1 histograma COLORSTICK:
 *
 *   Variacao = C / REF(C,1)
 *   HV       = STD(LN(Variacao), P) * SQRT(252)     ← Visible=false no engine
 *   MA1      = MA(HV, M)                            ← Visible=false no engine
 *   Histo    = 2 * (HV − MA1)                       ← única série do pacote
 *
 * STD do engine é AMOSTRAL (Bessel). O histograma é COLORSTICK: verde quando
 * positivo, vermelho quando negativo (a cor nominal da série é ignorada pelo
 * stick — ver LICOES). Paridade provada em
 * __tests__/volHistHisto.silverlight.test.js.
 */
import { ref, div, ln, std, mul, ma, sub } from "./silverlightDsl";
import { VolHistHisto as defaultOptions } from "./defaultOptionsForComputation";

const ANNUALIZATION = Math.sqrt(252); // SQRT(252) do engine

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, m } = options;
    const close = data.map((d) =>
      Number.isFinite(d.close) ? d.close : Number.NaN,
    );

    const variacao = div(close, ref(close, 1));
    const hv = mul(std(ln(variacao), period), ANNUALIZATION);
    const ma1 = ma(hv, m);
    const histo = mul(sub(hv, ma1), 2);

    return histo.map((v) =>
      Number.isFinite(v)
        ? { value: v, direction: v > 0 ? "up" : "down" }
        : undefined,
    );
  }

  calculator.undefinedLength = function () {
    const { period, m } = options;
    return Math.max(0, period + m - 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
